import { gql } from '@apollo/client';

export const UPDATE_COFFEE_CHAT_FREQUENCY = gql`
  mutation updateCoffeeChatFrequency($frequency: String!) {
    updateCoffeeChatFrequency(frequency: $frequency) {
      id
      coffeeChatFrequency
    }
  }
`;